
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/sobre/contato",
      function () {
        return require("private-next-pages/sobre/contato.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/sobre/contato"])
      });
    }
  